import React, { createContext, useState } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import styles from "./PageContext.module.css";
import FloatingAnchorButton from "../components/elements/button/floating";
import { DraggableWhatsAppButton } from "../components/elements/button/drag";

export const PageSettingsContext = createContext();

export function PageSettingsProvider({ children }) {
  const [pageHeader, setPageHeader] = useState(true);
  const [pageFooter, setPageFooter] = useState(true);
  const [draggable, setDraggable] = useState(true);
  const [floatingAnchor, setFloatingAnchor] = useState(true);

  return (
    <PageSettingsContext.Provider value={{ setPageHeader, setPageFooter, setDraggable, setFloatingAnchor }}>
        <div className={styles.PageWrapper}>
            { pageHeader && <Header />}
            <div className={styles.PageWrapper2}>
              <div className={styles.PageWrapper3}>
                <main className={styles.content}>
                  {children}
                </main>
              </div>
            </div>
            { draggable && <DraggableWhatsAppButton />}
            { floatingAnchor && <FloatingAnchorButton />}
            { pageFooter && <Footer />}
        </div>
    </PageSettingsContext.Provider>
  );   
}